const LOADING_CLASS = 'devise-form-wrapper__sign-in-button--loading';
// Keyframe attached to `.devise-form-wrapper__input:-webkit-autofill` in the
// login layout stylesheet. Chromium fills the field without firing 'input',
// but it does start this animation, so 'animationstart' is our autofill hook.
const AUTOFILL_ANIMATION_NAME = 'cwa-input-autofill';

const setDisabled = (button, value) => {
  const el = button;
  el.disabled = value;
};

// Spinner + disabled the moment a submit fires, so a slow connection gives
// feedback and a second click cannot double-submit. `loadingClass` lets a page
// outside the login layout reuse this with its own block's modifier.
export const startButtonLoading = (button, loadingClass = LOADING_CLASS) => {
  if (!button) return;

  const el = button;
  el.classList.add(loadingClass);
  el.setAttribute('aria-busy', 'true');
  el.disabled = true;
};

const gateSubmitOnInput = (input, submitButton) => {
  const update = () => {
    if (submitButton.classList.contains(LOADING_CLASS)) return;
    setDisabled(submitButton, input.value.trim() === '');
  };
  input.addEventListener('input', update);
  input.addEventListener('change', update);
  // Firefox fires 'input' on autofill; Chromium does not, so we also re-evaluate
  // the gate when the autofill CSS animation starts (see AUTOFILL_ANIMATION_NAME).
  input.addEventListener('animationstart', (event) => {
    if (event.animationName === AUTOFILL_ANIMATION_NAME) update();
  });
  update();
};

const initSignInGuard = () => {
  const form = document.querySelector('.devise-form-login form');
  if (!form) return;

  const activeInput = form.querySelector('.devise-form-wrapper__input:not([readonly])');
  const submitButton = form.querySelector('[type="submit"]');
  if (!activeInput || !submitButton) return;

  gateSubmitOnInput(activeInput, submitButton);

  form.addEventListener('submit', () => startButtonLoading(submitButton));
};

const initRecoveryGuard = () => {
  const form = document.querySelector('.devise-form-recovery-password form');
  if (!form) return;

  const emailInput = form.querySelector('.devise-form-wrapper__input');
  const submitButton = form.querySelector('[type="submit"]');
  if (!emailInput || !submitButton) return;

  gateSubmitOnInput(emailInput, submitButton);

  form.addEventListener('submit', () => startButtonLoading(submitButton));
};

export const initFormSubmitGuard = () => {
  initSignInGuard();
  initRecoveryGuard();
};
